module.exports = __webpack_public_path__ + "static/media/document-sync.663c8f42.svg";